/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse Complement Calculator (DNA / RNA) — Toolverse`)
};

const es_revcomp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Complemento Inverso (ADN / ARN) — Toolverse`)
};

const de_revcomp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechner für reverses Komplement (DNA / RNA) — Toolverse`)
};

const nl_revcomp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omgekeerd-complementcalculator (DNA / RNA) — Toolverse`)
};

const fr_revcomp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de complément inverse (ADN / ARN) — Toolverse`)
};

const it_revcomp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore del complemento inverso (DNA / RNA) — Toolverse`)
};

const pt_br2_revcomp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Complemento Reverso (DNA / RNA) — Toolverse`)
};

const pt_revcomp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Complemento Reverso (ADN / ARN) — Toolverse`)
};

const ja_revcomp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逆相補配列計算ツール (DNA / RNA) — Toolverse`)
};

const zh_revcomp_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反向互补计算器（DNA / RNA）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_meta_title", locale)
	if (locale === "en") return en_revcomp_meta_title(inputs)
	if (locale === "es") return es_revcomp_meta_title(inputs)
	if (locale === "de") return de_revcomp_meta_title(inputs)
	if (locale === "nl") return nl_revcomp_meta_title(inputs)
	if (locale === "fr") return fr_revcomp_meta_title(inputs)
	if (locale === "it") return it_revcomp_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_meta_title(inputs)
	if (locale === "pt") return pt_revcomp_meta_title(inputs)
	if (locale === "ja") return ja_revcomp_meta_title(inputs)
	return zh_revcomp_meta_title(inputs)
};